import React from 'react';
import { useNavigate } from 'react-router-dom';
import { portalCopy } from '../copy';
import { usePartnerBusiness } from '../context/PartnerBusinessContext';
import { formatListingDate, getListingValidUntil } from '../utils/listingPeriod';
import { PortalButton } from './PortalUi';

type WizardStepSuccessProps = {
  businessId: string;
};

const WizardStepSuccess: React.FC<WizardStepSuccessProps> = ({ businessId }) => {
  const navigate = useNavigate();
  const { business } = usePartnerBusiness();
  const validUntil = business ? getListingValidUntil(business) : null;

  return (
    <div className="flex flex-col items-center rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white px-6 py-14 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-chisme-primary/15 text-3xl">
        ✓
      </div>
      <h2 className="mt-6 font-instrument text-3xl italic tracking-[-0.01em] text-[#2a0f2a]">
        {portalCopy.wizard.success.title}
      </h2>
      <p className="mt-3 max-w-md font-jakarta text-[15px] leading-relaxed text-[#5a3158]">
        {portalCopy.wizard.success.subtitle}
      </p>
      {validUntil && (
        <p className="mt-3 max-w-md font-jakarta text-sm font-semibold text-chisme-primary">
          {portalCopy.wizard.success.validUntil(formatListingDate(validUntil))}
        </p>
      )}
      <PortalButton className="mt-8" onClick={() => navigate(`/partners/panel/${businessId}`)}>
        {portalCopy.wizard.success.cta}
      </PortalButton>
    </div>
  );
};

export default WizardStepSuccess;
